module.exports = __webpack_public_path__ + "img/logosvg.1b21ffbf.svg";